/* ============================================================
   Greenform — product page interactions (v8)
   - Per-size 360 viewer (frame 0 = main photo); drag/swipe to spin
   - Side arrows step through extra static product photos
   - Size change swaps the 360 set + price/variant
   - Pot change shows that variant's composite image (sticky); the
     no-pot swatch / the 360 thumbnail return to the 360
   - A single small spin cue (bottom-right) indicates the 360 is
     spinnable. It is gated by the first-visit rule in
     layout/theme.liquid: only a visitor's first session sees it, and
     only until they have spun two different products. Spinning here
     reports to window.GFSpinCue.record().
   - Stage adopts each image's real aspect ratio (no fixed square).
   - 2026-08-11: when the selected size has no 360 frame set, the stage
     falls back to the product's featured photo instead of showing an
     empty "360 coming soon" placeholder.
   - 2026-08-12: stock wording now comes from the locale file via data
     attributes, never from hardcoded strings in here.
   ============================================================ */
(function () {
  'use strict';
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  function readJSON(sel, fallback) {
    var el = section.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var productJson  = readJSON('[data-product-json]', null);
  /* Greenform 2026-08-11: the product's own featured photo, used as the stage
     fallback when the selected size has no 360 frame set. */
  var fallbackImage = (productJson && productJson.featured_image) ? productJson.featured_image : '';
  var sizeFrames   = readJSON('[data-size-frames]', {}) || {};
  var variantMedia = readJSON('[data-variant-media]', {}) || {};
  var extraPhotos  = readJSON('[data-extra-photos]', []) || [];

  /* ---- gallery elements ---- */
  var stage        = section.querySelector('[data-stage]');
  var spinWrap     = section.querySelector('[data-spin-viewer]');
  var staticImg    = section.querySelector('[data-stage-static]');
  var placeholder  = section.querySelector('[data-spin-placeholder]');
  var spinCue      = section.querySelector('[data-spin-cue]');
  var viewTag      = section.querySelector('[data-view-tag]');
  var thumbs       = section.querySelector('[data-thumbs]');
  var arrowPrev    = section.querySelector('[data-arrow-prev]');
  var arrowNext    = section.querySelector('[data-arrow-next]');
  if (!stage || !spinWrap) return;

  /* ---- stable id for the first-visit spin-cue counter ---- */
  var SPIN_ID = (productJson && productJson.handle)
    ? productJson.handle
    : (window.location.pathname.split('/').filter(Boolean).pop() || 'product');
  var spinMoves = 0;

  /* ---- option groups (rendered by main-product.liquid) ---- */
  var sizeGroup = section.querySelector('.size-row[data-option-group]');
  var potGroup  = section.querySelector('.pot-row[data-option-group]');

  /* ---- commerce elements ---- */
  var variantInput = section.querySelector('[data-variant-id-input]');
  var priceCurrent = section.querySelector('[data-current-price]');
  var priceCompare = section.querySelector('[data-compare-price]');
  var stockEl      = section.querySelector('[data-stock-indicator]');
  var stockLabel   = section.querySelector('[data-stock-label]');
  /* Greenform 2026-08-12: stock wording comes from the locale file via data
     attributes on [data-stock-indicator]. Do NOT hardcode these sentences here
     again — doing so silently overwrites the locale on every page load, which is
     what kept the old "ships within 2-4 business days" line on the storefront
     after the locale had already been corrected. */
  var STOCK_IN  = (stockEl && stockEl.getAttribute('data-stock-in'))  || '';
  var STOCK_OUT = (stockEl && stockEl.getAttribute('data-stock-out')) || '';
  var submitBtn    = section.querySelector('[data-add-to-cart-btn]');

  /* ---- option names from product JSON ---- */
  var optNames = [];
  if (productJson && productJson.options) {
    optNames = productJson.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
  }

  /* ---- state ---- */
  var SIZE = sizeGroup ? selectedVal(sizeGroup) : null;
  var POT  = potGroup  ? selectedVal(potGroup)  : null;
  var frames = [], spinFrame = 0, view = 'spin', dragging = false, startX = 0, startFrame = 0;
  var SENS = 14;

  function selectedVal(group) {
    var s = group.querySelector('.selected') || group.querySelector('[data-option-value]');
    return s ? s.getAttribute('data-option-value') : null;
  }
  function handleize(v) { return (v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function isNonePot(v) {
    var h = handleize(v);
    return !v || h === 'no-pot' || h === 'none' || h === 'nopot' || h === 'grow-pot' || h === 'plastic-grow-pot';
  }
  function markSelected(group, btn) {
    group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('selected'); });
    if (btn) btn.classList.add('selected');
  }
  function showCue(on) { if (spinCue) spinCue.classList.toggle('hidden', !on); }

  /* ---- stage adopts each image's real aspect ratio ---- */
  function applyStageRatio(img) {
    if (img && img.naturalWidth && img.naturalHeight) {
      stage.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
    }
  }
  function sizeStageToFirstFrame() {
    var first = spinWrap.children[0];
    if (!first) return;
    if (first.complete && first.naturalWidth) applyStageRatio(first);
    else first.addEventListener('load', function () { applyStageRatio(first); }, { once: true });
  }

  /* ---- 360 frames for the current size ---- */
  function currentFrames() {
    if (SIZE && sizeFrames[SIZE] && sizeFrames[SIZE].length) return sizeFrames[SIZE];
    if (sizeFrames._all && sizeFrames._all.length) return sizeFrames._all;
    return [];
  }
  function buildFrames() {
    frames = currentFrames();
    spinWrap.innerHTML = '';
    frames.forEach(function (url, i) {
      var im = document.createElement('img');
      im.src = url; im.draggable = false; im.alt = '';
      if (i === 0) im.className = 'active';
      spinWrap.appendChild(im);
    });
    spinFrame = 0;
    sizeStageToFirstFrame();
  }
  function setSpinFrame(f) {
    if (!frames.length) return;
    f = ((f % frames.length) + frames.length) % frames.length;
    var imgs = spinWrap.children;
    if (f !== spinFrame && dragging) {
      /* a real spin: after a few frames, count this product toward the
         two-spinners-and-the-cue-goes-away rule */
      spinMoves++;
      if (spinMoves === 3 && window.GFSpinCue) window.GFSpinCue.record(SPIN_ID);
    }
    if (imgs[spinFrame]) imgs[spinFrame].classList.remove('active');
    spinFrame = f;
    if (imgs[spinFrame]) imgs[spinFrame].classList.add('active');
  }

  /* ---- views ---- */
  function showSpin() {
    view = 'spin';
    spinWrap.style.display = '';
    if (frames.length) {
      if (staticImg) staticImg.hidden = true;
      if (placeholder) placeholder.hidden = true;
      spinWrap.hidden = false;
      showCue(frames.length > 1);
    } else if (fallbackImage && staticImg) {
      /* Greenform 2026-08-11: no 360 frames for the selected size. Show the
         product's featured photo instead of the "360 coming soon" placeholder,
         which otherwise left the stage completely empty — e.g. Zamioculcas,
         which has 14cm and 17cm frame sets but opens on 12cm. */
      spinWrap.hidden = true;
      spinWrap.style.display = 'none';
      if (placeholder) placeholder.hidden = true;
      if (staticImg.getAttribute('src') !== fallbackImage) staticImg.src = fallbackImage;
      staticImg.hidden = false;
      if (staticImg.complete && staticImg.naturalWidth) applyStageRatio(staticImg);
      else staticImg.addEventListener('load', function () { applyStageRatio(staticImg); }, { once: true });
      showCue(false);
    } else {
      if (staticImg) staticImg.hidden = true;
      spinWrap.hidden = true;
      if (placeholder) placeholder.hidden = false;
      showCue(false);
    }
    if (viewTag) viewTag.classList.add('hidden');
    setSpinFrame(spinFrame);
    syncThumbs();
  }
  function showStatic(url, label) {
    if (!staticImg) return;
    view = 'static';
    staticImg.src = url; staticImg.hidden = false;
    spinWrap.style.display = 'none';
    if (placeholder) placeholder.hidden = true;
    showCue(false);
    if (viewTag) { viewTag.classList.remove('hidden'); viewTag.textContent = label || ''; }
    dragging = false; stage.classList.remove('spinning');
    syncThumbs();
  }

  /* ---- variant resolution + commerce update ---- */
  function findVariant() {
    if (!productJson || !productJson.variants) return null;
    return productJson.variants.find(function (v) {
      return optNames.every(function (name, i) {
        var n = name.toLowerCase();
        if (n.indexOf('size') >= 0) return !SIZE || v.options[i] === SIZE;
        if (n.indexOf('pot') >= 0 || n.indexOf('colour') >= 0 || n.indexOf('color') >= 0) return !POT || v.options[i] === POT;
        return true;
      });
    });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function updateVariant(v) {
    if (!v) {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
      return;
    }
    if (variantInput) variantInput.value = v.id;
    if (priceCurrent) priceCurrent.textContent = money(v.price);
    if (priceCompare) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceCompare.textContent = money(v.compare_at_price); priceCompare.style.display = '';
      } else { priceCompare.style.display = 'none'; }
    }
    if (v.available) {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Add to cart'; }
      if (stockEl) stockEl.classList.remove('out');
      if (stockLabel && STOCK_IN) stockLabel.textContent = STOCK_IN;
    } else {
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sold out'; }
      if (stockEl) stockEl.classList.add('out');
      if (stockLabel && STOCK_OUT) stockLabel.textContent = STOCK_OUT;
    }
    try {
      if (v.id && history.replaceState) {
        var url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
    } catch (x) {}
  }

  /* ---- selection handlers ---- */
  function applyPotView() {
    var v = findVariant();
    updateVariant(v);
    if (isNonePot(POT)) { showSpin(); return; }
    var url = v && variantMedia[String(v.id)];
    if (url) showStatic(url, POT); else showSpin();
  }
  if (sizeGroup) {
    sizeGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]'); if (!btn) return;
      SIZE = btn.getAttribute('data-option-value'); markSelected(sizeGroup, btn);
      buildFrames();
      if (view === 'static' && !isNonePot(POT)) applyPotView();
      else { updateVariant(findVariant()); showSpin(); }
    });
  }
  if (potGroup) {
    potGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]'); if (!btn) return;
      POT = btn.getAttribute('data-option-value'); markSelected(potGroup, btn);
      applyPotView();
    });
  }

  /* ---- arrows + thumbnails over [360, extra photos...] ---- */
  function selectNonePot() {
    if (!potGroup) return;
    var none = null;
    potGroup.querySelectorAll('[data-option-value]').forEach(function (b) {
      if (!none && isNonePot(b.getAttribute('data-option-value'))) none = b;
    });
    if (none) { POT = none.getAttribute('data-option-value'); markSelected(potGroup, none); updateVariant(findVariant()); }
  }
  var slideCount = 1 + extraPhotos.length;
  var slideIdx = 0;
  function gotoSlide(i) {
    i = ((i % slideCount) + slideCount) % slideCount;
    slideIdx = i;
    if (i === 0) { selectNonePot(); showSpin(); }
    else showStatic(extraPhotos[i - 1], 'Photo ' + i);
  }
  if (arrowPrev) arrowPrev.addEventListener('click', function () { gotoSlide(slideIdx - 1); });
  if (arrowNext) arrowNext.addEventListener('click', function () { gotoSlide(slideIdx + 1); });

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    /* Nothing to switch between when there are no extra photos — the viewer is
       already the 360. Hide the whole thumbnail row so it takes no space. */
    if (!extraPhotos.length) { thumbs.style.display = 'none'; return; }
    thumbs.style.display = 'flex';
    var t0 = document.createElement('button');
    t0.type = 'button'; t0.className = 'thumb-item'; t0.dataset.slide = '0'; t0.setAttribute('aria-label', 'Spin 360');
    t0.innerHTML = '<div class="thumb-360"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2"/></svg></div>';
    t0.addEventListener('click', function () { slideIdx = 0; gotoSlide(0); });
    thumbs.appendChild(t0);
    extraPhotos.forEach(function (url, i) {
      var t = document.createElement('button');
      t.type = 'button'; t.className = 'thumb-item'; t.dataset.slide = String(i + 1);
      t.innerHTML = '<img src="' + url + '" alt="" loading="lazy">';
      t.addEventListener('click', function () { gotoSlide(i + 1); });
      thumbs.appendChild(t);
    });
  }
  function syncThumbs() {
    if (!thumbs) return;
    thumbs.querySelectorAll('.thumb-item').forEach(function (t) {
      var idx = parseInt(t.dataset.slide, 10);
      t.classList.toggle('active', view === 'spin' ? idx === 0 : idx === slideIdx && idx !== 0);
    });
  }

  /* ---- spin drag (only in 360 view) ---- */
  function spinActive() { return view === 'spin' && frames.length > 1; }
  stage.addEventListener('pointerdown', function (e) {
    if (!spinActive()) { dragging = false; return; }
    dragging = true; startX = e.clientX; startFrame = spinFrame;
    stage.classList.add('spinning');
    try { stage.setPointerCapture(e.pointerId); } catch (x) {}
  });
  stage.addEventListener('pointermove', function (e) {
    if (!dragging || !spinActive()) return;
    setSpinFrame(startFrame + Math.round((e.clientX - startX) / SENS));
  });
  function endDrag() { dragging = false; stage.classList.remove('spinning'); }
  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
  stage.addEventListener('pointerleave', endDrag);

  /* ---- wishlist (non-breaking) ---- */
  var wishlistBtn = section.querySelector('[data-wishlist-btn]');
  if (wishlistBtn) wishlistBtn.addEventListener('click', function () { wishlistBtn.textContent = 'Saved ♡'; setTimeout(function () { wishlistBtn.textContent = 'Save to wishlist'; }, 1500); });

  /* ---- init ---- */
  buildFrames();
  renderThumbs();
  updateVariant(findVariant());
  showSpin();
})();
